import i18n from "@/i18n";

export const stylesFields = [
    {
        key: "name",
        label: i18n.t("style.name"),
        sortable: true
    },
    {
        key: "postType",
        label: i18n.t("style.colItemType"),
        sortable: true,
        formatter: localizeType
    },
    {
        key: "actions",
        label: ""
    }
];

export const ChannelStyleFields = [
    {
        key: "name",
        label: i18n.t("channelStyles.name"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        sortable: true,
        formatter: localizeChannelStylesType
    },
    {
        key: "actions",
        label: ""
    }
];

export const designButtonStyleFields = [
    {
        key: "name",
        label: i18n.t("designButtonStyles.name"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];

function localizeType(value: string) {
    return i18n.t("posts." + value);
}

function localizeChannelStylesType(value: string) {
    switch (value) {
    case "duration":
        return i18n.t("channelStyles.durationTitle");
    case "counter":
        return i18n.t("channelStyles.counterTitle");
    case "menuStyle":
        return i18n.t("channelStyles.menuStyle");
    }
}
